import { render, staticRenderFns } from "./RequestCall.vue?vue&type=template&id=94006c24&"
import script from "./RequestCall.vue?vue&type=script&lang=js&"
export * from "./RequestCall.vue?vue&type=script&lang=js&"
import style0 from "./RequestCall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports